import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Image } from "primereact/image";
import { SelectButton } from "primereact/selectbutton";
import { Steps } from "primereact/steps";
import { useState } from "react";
import { BsBarChartSteps } from "react-icons/bs";
import { FaVideo } from "react-icons/fa";
import ReactPlayer from "react-player";

function TutorialDialog({ close }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [seletorVideo, setSeletorVideo] = useState("passos");
  const options = [
    {
      label: "Passos",
      value: "passos",
      icon: <BsBarChartSteps />,
    },
    { label: "Vídeo", value: "video", icon: <FaVideo /> },
  ];
  const items = [
    { id: "1", label: "Selecionar Forma de Negociação" },
    { id: "2", label: "Selecionar as Cobranças" },
    { id: "3", label: "Regras de Seleção" },
    { id: "4", label: "Seleciona Forma de Pagamento" },
    { id: "5", label: "Continue Normalmente" },
  ];

  const botaoTipoPagamento = (option) => {
    return (
      <div className={`flex justify-between w-full ${option.className}`}>
        <h6>{option.label}</h6>
        <i style={{ fontSize: "3vh" }}>{option.icon}</i>
      </div>
    );
  };

  const selecaoTipo = () => {
    switch (activeIndex) {
      case 0:
        return (
          <div className="mt-[2vh]">
            <h5 className="font-lato-bold mb-[1vh] text-center text-[2vh] lg:text-[3vh]">
              Primeiro selecione se deseja fazer a negociação de forma parcial ou total
            </h5>
            <Image preview src="2.png" />
          </div>
        );
      case 1:
        return (
          <div className="mt-[2vh]">
            <h5 className="font-lato-bold mb-[1vh] text-center text-[2vh] lg:text-[3vh]">
              Depois selecione os débitos que deseja negociar
            </h5>
            <Image preview src="3.png" />
          </div>
        );
      case 2:
        return (
          <div className="mt-[2vh]">
            <h5 className="font-lato-bold mb-[1vh] text-center text-[2vh] lg:text-[3vh]">
              Essas são as regras para seleção de débitos
            </h5>
            <div className="grid lg:flex w-full gap-[1vh]">
              <div
                className="grid lg:w-1/2 border-[0.1vh]  rounded-lg p-[1vh] border-black
              bg-green-100"
              >
                <ol className="text-[2vh] lg:text-[2.7vh] font-lato-bold">
                  <li>- Os débitos são listados dos mais antigos para os mais recentes.</li>
                  <li>
                    - A negociação parcial de débitos só pode ser efetuada selecionando dos débitos mais antigos aos
                    mais novos, exemplo: Janeiro/2022, Fevereiro/2022, Março/2022.
                  </li>
                  <li>
                    - Em casos de títulos protestados, você deverá efetuar a negociação de todos os débitos em atraso e,
                    por fim, quitar e cancelar o protesto
                  </li>
                </ol>
              </div>
              <div className="lg:w-1/2 ">
                <Image preview src="4.png" />
              </div>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="mt-[2vh]">
            <h5 className="font-lato-bold mb-[1vh] text-center text-[2vh] lg:text-[3vh]">
              Depois selecione a forma de pagamento
            </h5>
            <Image preview src="5.png" />
          </div>
        );
      case 4:
        return (
          <div className="mt-[2vh]">
            <h5 className="font-lato-bold mb-[1vh] text-center text-[2vh] lg:text-[3vh]">
              Depois selecione as parcelas e continue
            </h5>
            <Image preview src="6.png" />
          </div>
        );

      default:
        break;
    }

    <div>
      <h5>Primeiro selecione se deseja fazer a negociação de forma parcial ou total</h5>
      <img src="2.png" />
    </div>;
  };

  return (
    <Dialog
      visible
      draggable={false}
      maximizable
      onHide={() => close()}
      header="Como negociar parcialmente seus débitos"
      style={{
        width: window.innerWidth > 820 ? "80vw" : "100vw",
        height: window.innerWidth > 820 ? "100vh" : "100vh",
        textAlign: "center",
        // borderRadius: '30px',
        // padding: '10px'
      }}
      className="boletosDialog"
    >
      <div className="grid text-justify font-lato">
        <h6 className="mb-[3vh]">
          Olá! A Direto agora possui uma nova forma de negociar, agora você pode negociar apenas parte da sua dívida,
          abaixo um breve passo a passo de como negociar dessa maneira:
        </h6>
        <h6 className="text-center">Escolha a melhor forma de visualizar o tutorial:</h6>
        <div className="flex justify-center py-[2vh]">
          <div className="h-[7vh] w-full lg:w-3/4 xl:w-2/4 paymentTypeButton ">
            <SelectButton
              value={seletorVideo}
              onChange={(e) => setSeletorVideo(e.value)}
              options={options}
              itemTemplate={botaoTipoPagamento}
            />
          </div>
        </div>

        {seletorVideo === "passos" ? (
          <>
            <Steps
              model={items}
              activeIndex={activeIndex}
              onSelect={(e) => setActiveIndex(e.index)}
              readOnly={false}
              className="custom-steps"
            />
            {selecaoTipo()}
          </>
        ) : (
          <div className="w-full flex justify-center">
            <div className="text-blue-900 w-full lg:w-3/5 bg-[#011728] card p-[2vh]">
              <ReactPlayer
                width="100%"
                controls={true}
                config={{
                  youtube: {
                    playerVars: {
                      autoplay: 0,
                      controls: 1,
                      color: "white",
                      hl: "pt",
                      rel: 0,
                      showinfo: 0,
                    },
                  },
                }}
                url="https://youtu.be/bO84FGT00mY?si=-7XoRhUfJPAdFPHa"
              ></ReactPlayer>
            </div>
          </div>
        )}
      </div>
      <div className="w-full mt-[2vh]">
        <Button onClick={() => close()} label="Entendi" severity="success" className="w-1/2" />
      </div>
    </Dialog>
  );
}

export default TutorialDialog;
